import Preview from 'src/component/Preview';
import md from '@uiw/react-native/lib/QuickList/README.md';

export const Component = () => <Preview {...md} path="/packages/core/src/QuickList/README.md" />;
